import React from 'react';
import { Link } from 'react-router-dom';

export default function Menu(){
    return(
        <nav className="navbar navbar-inverse">
            <div className="container">
                <div className="navbar-header">
                    <Link to="/" className="navbar-brand">Music Player</Link>
                    <button className="navbar-toggle" data-toggle="collapse" data-target="#menu">
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                    </button>
                </div>
                <div className="navbar-collapse collapse" id="menu">
                    <ul className="nav navbar-nav">
                        <li>
                            <Link to="/music">Music</Link>
                        </li>
                        <li>
                            <Link to="/about">About</Link>
                        </li>
                        <li>
                            <Link to="/contact">Contact</Link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}